export default "__VITE_ASSET__D$Gs7$c5__"